/*!
 * KoliBri - The accessible HTML-Standard
 */
import { b as validateAlignment } from './align-C8fl12z_.js';
import './common-D-vggmh2.js';

const validateTooltipAlign = (component, value) => {
    validateAlignment(component, '_tooltipAlign', value);
};

export { validateTooltipAlign as v };
//# sourceMappingURL=tooltip-align-BQmLWbBy.js.map

//# sourceMappingURL=tooltip-align-BQmLWbBy.js.map